//IN THIS FILE WE DEFINE THE ACTIONS FOR REDUX

//WEB3
export function web3Loaded(connection) {
    return {
        type: 'WEB3_LOADED',
        connection: connection
    }
}

//ACCOUNTS
export function web3AccountLoaded(account) {
    return {
        type: 'WEB3_ACCOUNT_LOADED',
        account: account
    }
}

//TOKEN
export function tokenLoaded(contract) {
    return {
        type: 'TOKEN_LOADED',
        contract: contract
    }
}

//EXCHANGE
export function exchangeLoaded(contract) {
    return {
        type: 'EXCHANGE_LOADED',
        contract: contract
    }
}

//CANCELLED ORDERS LOADED
export function cancelledOrdersLoaded(cancelledOrders) {
    return {
      type: 'CANCELLED_ORDERS_LOADED',
      cancelledOrders: cancelledOrders
    }
  }

  //CANCELLED ORDERS LOADED
export function filledOrdersLoaded(filledOrders) {
    return {
      type: 'FILLED_ORDERS_LOADED',
      filledOrders: filledOrders
    }
  }

    //ALL ORDERS LOADED
export function allOrdersLoaded(allOrders) {
    return {
      type: 'ALL_ORDERS_LOADED',
      allOrders: allOrders
    }
  }

  //ORDER cancelling

export function orderCancelling() {
  return {
      type: 'ORDER_CANCELLING'
  }
}

//ORDER CANCELLED
export function orderCancelled(order) {
  return {
    type: 'ORDER_CANCELLED',
    order
  }
}
 

//FILL ORDER
export function orderFilling() {
  return {
    type: 'ORDER_FILLING'
  }
}

//ORDER FILLED
export function orderFilled(order) {
  return {
   type: 'ORDER_FILLED',
   order
  }
}

//BALANCES ACTIONS
//ETHER WALLET BALANCE LOADED
export function etherBalanceLoaded(balance){
  return {
    type: 'ETHER_BALANCE_LOADED',
    balance
  }
}

//TOKEN WALLET BALANCE LOADED
export function tokenBalanceLoaded(balance){
  return {
    type: 'TOKEN_BALANCE_LOADED',
    balance
  }
}

//EXCHANGE ETHER BALANCE LOADED 
export function exchangeEtherBalanceLoaded(balance) {
  return {
    type: 'EXCHANGE_ETHER_BALANCE_LOADED',
    balance
  }
}

//EXCHANGE TOKEN BALANCE LOADED   
export function exchangeTokenBalanceLoaded(balance) {
  return {
    type: 'EXCHANGE_TOKEN_BALANCE_LOADED',
    balance
  }
}

//ALL BALANCES LOADED
export function balancesLoaded() {
  return {
    type: 'BALANCES_LOADED'
  }
}

//BALANCES IS LOADING
export function balancesLoading() {
  return {
    type: 'BALANCES_LOADING'
  }
}


//etherDepositAmountChanged 
export function etherDepositAmountChanged(amount) {
  return {
    type: 'ETHER_DEPOSIT_AMOUNT_CHANGED',
    amount
  }
}

//etherWithdrawAmountChanged
export function etherWithdrawAmountChanged(amount) {
  return {
    type: 'ETHER_WITHDRAW_AMOUNT_CHANGED',
    amount
  }
}

//tokenDepositAmountChanged
export function tokenDepositAmountChanged(amount) {
  return {
    type: 'TOKEN_DEPOSIT_AMOUNT_CHANGED',
    amount
  }
}

//tokenWithdrawAmountChanged
export function tokenWithdrawAmountChanged(amount) {
  return {
    type: 'TOKEN_WITHDRAW_AMOUNT_CHANGED',
    amount
  }
}

//createBuyOrder
export function buyOrderAmountChanged(amount) {
  return {
    type: 'BUY_ORDER_AMOUNT_CHANGED',
    amount
  }
}

export function buyOrderPriceChanged(price) {
  return {
    type: 'BUY_ORDER_PRICE_CHANGED',
    price
  }
}

export function buyOrderMaking(price) {
  return{
    type: 'BUY_ORDER_MAKING'
  }
}



//createSellOrder

export function sellOrderAmountChanged(amount) {
  return{
    type: 'SELL_ORDER_AMOUNT_CHANGED',
    amount
  }
}

export function sellOrderPriceChanged(price){
  return {
    type: 'SELL_ORDER_PRICE_CHANGED',
    price
  }
}

export function sellOrderMaking(price){
  return {
    type: 'SELL_ORDER_MAKING',
    price
  }
  
}


//Generic order finished
export function orderMade(order) {
  return{
    type: 'ORDER_MADE',
    order
  }
}